import React, { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { CheckCircle2, HeartHandshake } from 'lucide-react';

const ThankYou = ({ onReset }) => {
  useEffect(() => {
    // Launch celebratory confetti effect
    const duration = 2.5 * 1000;
    const end = Date.now() + duration;

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: ['#c0392b', '#e74c3c', '#f39c12', '#800020']
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: ['#c0392b', '#e74c3c', '#f39c12', '#800020']
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };

    frame();
  }, []);

  return (
    <div className="card-survey text-center py-12 px-6 max-w-xl mx-auto animate-fadeIn">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner text-green-600">
        <CheckCircle2 size={48} />
      </div>

      <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-800 mb-3">
        ¡Muchas Gracias por su Participación!
      </h2>

      <p className="text-slate-600 text-sm sm:text-base leading-relaxed mb-8 max-w-md mx-auto">
        Sus respuestas han sido registradas exitosamente. Sus valiosos comentarios nos ayudan a seguir ofreciendo experiencias de excelencia en Cardio Summit.
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 rounded-full text-slate-700 text-xs font-semibold">
          <HeartHandshake className="w-4 h-4 text-adium-red" />
          <span>Equipo Cardio Summit ADIUM</span>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
